"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalWidth = void 0;
var react_1 = __importDefault(require("react"));
var react_modal_1 = __importDefault(require("react-modal"));
var react_jss_1 = require("react-jss");
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("..");
var ModalCloseButton_1 = __importDefault(require("./ModalCloseButton"));
var ModalWidth;
(function (ModalWidth) {
    ModalWidth["fixed"] = "fixed";
    ModalWidth["full"] = "full";
})(ModalWidth = exports.ModalWidth || (exports.ModalWidth = {}));
react_modal_1.default.setAppElement('#root');
var useStyles = (0, react_jss_1.createUseStyles)(function (_a) {
    var _b;
    var colors = _a.colors, borderRadius = _a.borderRadius, margins = _a.margins, breakpoints = _a.breakpoints;
    return (_b = {
            fullscreen: {
                borderRadius: 0,
            },
            content: function (styles) { return (__assign(__assign({ outline: 'none', top: '50%', left: '50%', right: 'auto', bottom: 'auto', marginRight: '-50%', transform: 'translate(-50%, -50%)', width: '95%', maxHeight: '95vh', borderRadius: borderRadius.sm, zIndex: 10001, position: 'absolute', color: colors.Grey[1000], background: colors.Grey[0], overflow: 'auto', boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.1)", padding: margins.sm, boxSizing: 'border-box' }, styles), { '&$fullscreen': {
                    top: 0,
                    left: 0,
                    right: 0,
                    marginRight: 0,
                    borderRadius: 0,
                    width: 'auto',
                    maxHeight: '100%',
                    bottom: 0,
                    transform: 'none',
                } })); },
            overlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, .5)',
                zIndex: 1000,
            }
        },
        _b["@media (max-width:".concat(breakpoints.sm, "px)")] = {
            content: function () { return ({
                maxWidth: '100vh',
                maxHeight: '100vh',
                height: '100vh',
                width: '100vw',
                padding: margins.md,
                borderRadius: 0,
            }); },
        },
        _b);
});
var Modal = function (_a) {
    var _b;
    var onClose = _a.onClose, isOpen = _a.isOpen, children = _a.children, className = _a.className, styles = _a.styles, canClose = _a.canClose, fullScreen = _a.fullScreen, width = _a.width;
    var classes = useStyles(__assign({ width: width === ModalWidth.fixed ? '500px' : '100vw' }, styles));
    return (react_1.default.createElement(react_modal_1.default, { onRequestClose: canClose ? onClose : undefined, overlayClassName: classes.overlay, className: (0, classnames_1.default)(className, classes.content, (_b = {},
            _b[classes.fullscreen] = fullScreen,
            _b)), isOpen: isOpen },
        canClose && (react_1.default.createElement(ModalCloseButton_1.default, { fullScreen: fullScreen, onClose: onClose })),
        children,
        react_1.default.createElement(__1.GradientStroke, null)));
};
Modal.defaultProps = {
    canClose: true,
    isOpen: false,
    width: ModalWidth.fixed,
};
exports.default = Modal;
//# sourceMappingURL=index.js.map